/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelDataEntry', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModelDataEntry'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelDataEntryApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelDataEntry, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, ForecastModelDataEntry, FileTransferHelperEntity) {
  'use strict';

  /**
   * ForecastModelDataEntry service.
   * @module api/ForecastModelDataEntryApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelDataEntryApi. 
   * @alias module:api/ForecastModelDataEntryApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelDataEntryAddAllPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForecastModelDataEntry>} body 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.forecastModelDataEntryAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryAddPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelDataEntry} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withNotification  (default to false)
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelDataEntryAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'withNotification': opts['withNotification']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryDeleteAllPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryDeleteGet operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryID 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryDeleteGet = function(_4SAPIAppID, entryID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryDeleteGet";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntryDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryEditAllPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForecastModelDataEntry>} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withNotifications  (default to false)
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryEditAllPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'withNotifications': opts['withNotifications']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryEditPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelDataEntry} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withNotification  (default to false)
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryEditPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'withNotification': opts['withNotification']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryGenerateTemplateGet operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryGenerateTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.valueWriteRule 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryGenerateTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.forecastModelDataEntryGenerateTemplateGet = function(_4SAPIAppID, entryID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryGenerateTemplateGet";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntryGenerateTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID,
        'valueWriteRule': opts['valueWriteRule']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/generateTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryImportDataPut operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryImportDataPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importData
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} entryID 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryImportDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryImportDataPut = function(_4SAPIAppID, body, entryID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryImportDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelDataEntryImportDataPut";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntryImportDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/importData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryLoadGet operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelDataEntry} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryID 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelDataEntry}
     */
    this.forecastModelDataEntryLoadGet = function(_4SAPIAppID, entryID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryLoadGet";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntryLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelDataEntry;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntrySendReminderGet operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntrySendReminderGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendReminder
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryID 
     * @param {Integer} statusID 
     * @param {String} managerNote 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntrySendReminderGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntrySendReminderGet = function(_4SAPIAppID, entryID, statusID, managerNote, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntrySendReminderGet";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntrySendReminderGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling forecastModelDataEntrySendReminderGet";
      }

      // verify the required parameter 'managerNote' is set
      if (managerNote == undefined || managerNote == null) {
        throw "Missing the required parameter 'managerNote' when calling forecastModelDataEntrySendReminderGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID,
        'statusID': statusID,
        'managerNote': managerNote
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/sendReminder', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDataEntryTouchGet operation.
     * @callback module:api/ForecastModelDataEntryApi~forecastModelDataEntryTouchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * touch
     * @param {String} _4SAPIAppID 
     * @param {Integer} entryID 
     * @param {Integer} statusID 
     * @param {String} responsibleUserNote 
     * @param {module:api/ForecastModelDataEntryApi~forecastModelDataEntryTouchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDataEntryTouchGet = function(_4SAPIAppID, entryID, statusID, responsibleUserNote, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDataEntryTouchGet";
      }

      // verify the required parameter 'entryID' is set
      if (entryID == undefined || entryID == null) {
        throw "Missing the required parameter 'entryID' when calling forecastModelDataEntryTouchGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling forecastModelDataEntryTouchGet";
      }

      // verify the required parameter 'responsibleUserNote' is set
      if (responsibleUserNote == undefined || responsibleUserNote == null) {
        throw "Missing the required parameter 'responsibleUserNote' when calling forecastModelDataEntryTouchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': entryID,
        'statusID': statusID,
        'responsibleUserNote': responsibleUserNote
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelDataEntry/touch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
